import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../../@bizkeytech/base/core";
import ApiEndpoints from "../../endpoints";
import * as models from "./index.types";
import {CancelToken} from "axios";

/**@inheritDoc*/
export class UiComponentsController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Fetches the UI components from the server.
     *
     * @param request           The request to fetch the UI components.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async list(request: models.GetApplicationUIComponentsRequest, cancelToken?: CancelToken): models.GetApplicationUIComponentsResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.uiComponent.getData,
            cancelToken: cancelToken,
            params: {applicationName: request.applicationName},
            showErrorToast: false,
        });
    }

    /**
     * Saves the UI components to the server.
     *
     * @param request           The request to save the UI components.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async save(request: models.SaveApplicationUIComponentRequest, cancelToken?: CancelToken): models.SaveApplicationUIComponentResponse {
        return this.executor?.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.uiComponent.saveData,
            cancelToken: cancelToken,
            data: request,
            showErrorToast: false,
        });
    }
}

export * from "./index.types";
export default UiComponentsController;